import React from 'react';

const StatusIndicator = ({ status }) => {
  const getStatusColor = () => {
    switch (status.toLowerCase()) {
      case 'paid':
        return '#40D88E'; // Green
      case 'pending':
        return '#FFAC2C'; // Orange
      default:
        return '#40D88E'; // Default to green
    }
  };

  return (
    <div
      className="w-fit-content f-12 f-500"
      style={{
        borderRadius: "20px",
        color: "#fff",
        background: getStatusColor(),
        padding: "1px 7px",
      }}
    >
      {status}
    </div>
  );
};

export default StatusIndicator; 